import {
  InteractionType,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated,
  useMsalAuthentication,
} from "@azure/msal-react";
import { FC, PropsWithChildren, useEffect } from "react";
import { algoApiRequest } from "./authConfig";
import { CircularProgress, Container, Stack, Typography } from "@mui/material";
import { msalInstance } from ".";

export const AuthWrapper: FC<PropsWithChildren<{}>> = ({ children }) => {
  const { login, error, result } = useMsalAuthentication(
    InteractionType.Silent,
    algoApiRequest
  );
  const activeAccount = msalInstance.getActiveAccount();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (error instanceof InteractionRequiredAuthError) {
      console.warn("Silent login was unsuccessful. Redirecting.");
      login(InteractionType.Redirect, algoApiRequest);
    }

    if (result?.account != null) {
      msalInstance.setActiveAccount(result.account);
    }

    if (error && !(error instanceof InteractionRequiredAuthError)) {
      console.error(
        'Skynet Authentication error - this should not happen "often"',
        error
      );
      login(InteractionType.Redirect, algoApiRequest);
    }
  }, [error, login, result]);

  return (
    <>
      <AuthenticatedTemplate>
        {activeAccount && isAuthenticated ? (
          children
        ) : (
          <Container
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              height: "100vh",
              width: "100%",
            }}
          >
            <Stack direction="row" spacing={2} alignItems="center">
              <Typography variant="subtitle1">Loading account...</Typography>
              <CircularProgress size={26} sx={{ color: "#FF8C3D" }} />
            </Stack>
          </Container>
        )}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Container sx={{ display: "flex", justifyContent: "center" }}>
          <Typography sx={{ mt: 35 }} variant="h2">
            Signing in...
          </Typography>
        </Container>
      </UnauthenticatedTemplate>
    </>
  );
};
